import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class SubDirectoryTemplateItem<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<SubDirectoryTemplateItem> = {
  id: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const subDirectoryTemplateItemEntityDefinition: EntitiyDefinition<SubDirectoryTemplateItem> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'SubDirectoryTemplateItem',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
